// extracted by mini-css-extract-plugin
module.exports = {"tagSection":"_08978c8","standingsSkeleton":"_b6e6dc4","titleSkeleton":"_1a15eab","textSkeleton":"_92367cc","tableSkeleton":"_d571f4a"};